import React, { Suspense, lazy, useEffect } from "react";
import { Spin } from "antd";
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom";
import Dashboard from "./dashboard";

import Pages from "./pages";

import withAdminLayout from "../../layout/withAdminLayout";
import PoliciesRoute from "./policies";
import CarriersRoute from "./carriers";
import AgentsRoute from "./agents";
import MessagesRoute from "./messages";
import EmailTemplatesRoute from "./emailTemplates";
import ContractTemplatesRoute from "./contractTemplates";
import { getUserToken } from "../../hooks/authFunctions";
import { useSignOutGeneral } from "../../hooks/generalFunction";

const QuotesRoute = lazy(() => import("./quotes"));

/**
 * Admin routes
 * @returns
 */
function Admin() {
  const { path } = useRouteMatch();
  const history = useHistory();

  const signOut = useSignOutGeneral();

  const SignOut = async () => {
    //logout aws session
    signOut();
  };

  useEffect(() => {
    const checkUserSession = async () => {
      try {
        const user = await getUserToken();
        const token = user.accessToken.toString();
        // //console.log("User is signed in:", token);
        if (token === "") {
          history.push("/");
        }
        // User session is valid
      } catch (error) {
        //logout user
        SignOut();
        // console.log("User is not signed in:", error);
        history.push("/");
      }
    };

    checkUserSession();
  }, []);

  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }>
        <Route path={path} component={Dashboard} />
        <Route path={`${path}`} component={Pages} />
        {/* quotes */}
        <Route path={`${path}/quotes`} component={QuotesRoute} />
        {/* policies */}
        <Route path={`${path}/policies`} component={PoliciesRoute} />
        {/* carriers */}
        <Route path={`${path}/carriers`} component={CarriersRoute} />
        {/* agents */}
        <Route path={`${path}/agents`} component={AgentsRoute} />
        {/* messages */}
        <Route path={`${path}/messages`} component={MessagesRoute} />
        {/* email templates */}
        <Route path={`${path}/email-templates`} component={EmailTemplatesRoute} />
        {/* contract templates */}
        <Route path={`${path}/contract-templates`} component={ContractTemplatesRoute} />
      </Suspense>
    </Switch>
  );
}

export default withAdminLayout(Admin);
